import script from "./JaLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./JaLogin.vue?vue&type=script&setup=true&lang=js"

import "./JaLogin.vue?vue&type=style&index=0&id=412381a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412381a0"]])

export default __exports__